// Module
var code = "<img ng-class=\"avatarClass\" ng-src=\"{{ avatar }}\"/> ";
// Exports
export default code;